/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fullscreen': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M285.867 810.667H384v42.666H213.333V682.667H256V780.8l128-128 29.867 29.867-128 128zm494.933 0l-128-128 29.867-29.867 128 128v-98.133h42.666v170.666H682.667v-42.666H780.8zM285.867 256l128 128L384 413.867l-128-128V384h-42.667V213.333H384V256h-98.133zm494.933 0h-98.133v-42.667h170.666V384h-42.666v-98.133l-128 128L652.8 384l128-128z" _fill="#444"/>'
  }
})
